module.exports = __webpack_public_path__ + "media/images/australian-government-c04df5d0946c0aac083cba1ece015981.png";